export default __webpack_public_path__ + "static/media/XEMP-25.d404ae50.jpg";